import {
  LIST_RESPONSIBLE_EMAIL_TYPE_REQUEST,
  LIST_RESPONSIBLE_EMAIL_TYPE_SUCCESS,
  LIST_RESPONSIBLE_EMAIL_TYPE_ERROR,
} from '../../actions';

export const listResponsibleEmailTypeRequest = () => ({
  type: LIST_RESPONSIBLE_EMAIL_TYPE_REQUEST,
});
export const listResponsibleEmailTypeSuccess = (responsibleEmailTypes) => ({
  type: LIST_RESPONSIBLE_EMAIL_TYPE_SUCCESS,
  payload: responsibleEmailTypes,
});
export const listResponsibleEmailTypeError = (message) => ({
  type: LIST_RESPONSIBLE_EMAIL_TYPE_ERROR,
  payload: { message },
});
